module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_yoso_studio-6041b60ff7b5abb3733b75006af85388.webp";